(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('VersionInfoController', ["$scope", "$modalInstance", "systemDao", "feature", function ($scope, $modalInstance, systemDao, feature) {
        $scope.close = function () {
            $modalInstance.close();
        };
        $scope.systemVersion = null;
        $scope.customerComponents = null;
        $scope.isError = false;
        $scope.isLoading = true;
        $scope.loadVersion = function () {
            systemDao.version().then(function (response) {
                var systemVersion = {
                    version: response.data.version_info.version,
                    build: response.data.version_info.build
                };
                $scope.systemVersion = systemVersion;
                $scope.isLoading = false;
            }).catch(function () {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        };
        $scope.loadComponensVersions = function () {
            systemDao.environmentComponents().then(function (response) {
                var services = response.data.services;
                var engines = response.data.engines;
                var customerComponents = [].concat(services, engines);
                $scope.customerComponents = customerComponents;
                $scope.isLoading = false;
            }).catch(function () {
                $scope.loadVersion();
            });
        };
        if (feature.displayFarmComponentsVersions) {
            $scope.loadComponensVersions();
        } else {
            $scope.loadVersion();
        }
    }]);
    m.factory('versionInfoModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (options) {
                var templateUrl = path('gui-v2').ctrl('version-information-modal').template();
                var instance = $modal.open({
                    templateUrl: templateUrl,
                    controller: 'VersionInfoController',
                    windowClass: 'version-info-modal',
                    resolve: { options: _.constant(options) }
                });
                return instance.result;
            }
        };
    }]);
}());